// extracted by mini-css-extract-plugin
export default {"listTabContainer":"OrderTabs_listTabContainer__K3t5j"};